import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList, queryIdTree } from '@/api/api';
import DepartPostDrawer from "./modules/DepartPostDrawer";
import Vue from 'vue';
import { getAction, deleteAction } from '@/api/manage';
export default {
  name: 'DepartPostList',
  mixins: [JeecgListMixin],
  components: {
    DepartPostDrawer: DepartPostDrawer
  },
  data: function data() {
    return {
      pagePath: '/sys/post/find',
      pageTitle: '部门岗位',
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      expandedKeys: [],
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'departName',
        colName: 'depart_name',
        title: '所在部门',
        align: 'center'
      }, {
        dataIndex: 'code',
        colName: 'code',
        title: '岗位编号',
        align: 'center'
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '岗位名称',
        align: 'center'
      }, {
        dataIndex: 'postName',
        colName: 'post_name',
        title: '岗位类型',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        postType: '/sys/post/type'
      },
      departTree: [],
      departList: [],
      postTypeList: [],
      departId: '',
      queryParam: {}
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  created: function created() {
    this.loadDepartTree();
    this.loadPostTypeList();
  },
  methods: {
    // 树形
    onExpand: function onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
    },
    loadDepartTree: function loadDepartTree() {
      var that = this;
      queryIdTree().then(function (res) {
        if (res.success) {
          that.departTree = res.result;
          res.result.forEach(function (v, i) {
            that.expandedKeys.push(v.key);
          });
        }
      });
    },
    loadPostTypeList: function loadPostTypeList() {
      var _this = this;

      var param = {
        pageNo: 1,
        pageSize: 99999
      };
      getAction(this.url.postType, param).then(function (res) {
        if (res.success) {
          _this.postTypeList = res.result.records;
        }
      });
    },
    onTreeSelect: function onTreeSelect(selectedKeys, info) {
      if (selectedKeys.length <= 0) return;

      try {
        var selectKey = selectedKeys[0]; // 部门查询

        this.departId = selectKey;
        this.queryParam.departId = selectKey;
        this.queryParam.orgCode = info.selectedNodes[0].data.props.orgCode;
        this.loadData(1);
      } catch (e) {}
    },
    handleAdd: function handleAdd() {
      this.$refs.modalForm.departId = this.departId;
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    handleDelete: function handleDelete(id) {
      // if (!this.url.delete) {
      //   this.$message.error('请设置url.delete属性!')
      //   return
      // }
      var that = this;
      deleteAction("/sys/post", {
        id: id
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          }); //this.queryParam = {}

          that.loadData();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    batchDel: function batchDel() {
      // if(!this.url.deleteBatch){
      //   this.$message.error("请设置url.deleteBatch属性!")
      //   return
      // }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择' + this.pageTitle + '记录！');
        return;
      } else {
        var ids = '';

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中' + this.pageTitle + '数据?',
          onOk: function onOk() {
            deleteAction("/sys/post/deleteBatch", {
              ids: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadData();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    }
  }
};